import { render, staticRenderFns } from "./Tenant.vue?vue&type=template&id=3ee67c1c"
import script from "./Tenant.vue?vue&type=script&lang=js"
export * from "./Tenant.vue?vue&type=script&lang=js"
import style0 from "./Tenant.vue?vue&type=style&index=0&id=3ee67c1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports